import { render, staticRenderFns } from "./ContestEventPopup.vue?vue&type=template&id=b35a6a64&scoped=true&"
import script from "./ContestEventPopup.vue?vue&type=script&lang=js&"
export * from "./ContestEventPopup.vue?vue&type=script&lang=js&"
import style0 from "./ContestEventPopup.vue?vue&type=style&index=0&id=b35a6a64&lang=scss&scoped=true&"
import style1 from "./ContestEventPopup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a6a64",
  null
  
)

export default component.exports